<template>
  <header class="header">
    <div class="header__wrap">
      <div class="header__left">
        <a href="https://solanabitcat.com/" class="header__link">
          <img class="header__logo" src="@/assets/bitcat-logo.png" alt="Logo">
        </a>
        <div id="google_translate_element" class="custom-translate"></div>
      </div>
      <nav class="header__nav">
        <button 
          class="universe-ai-button" 
          :class="{ 'ai-enabled': isAiEnabled }"
          @click="toggleAi"
        >
          <span class="button-text">AI</span>
          <span class="switch-track">
            <span class="switch-thumb">
              <i class="fas fa-robot"></i>
            </span>
          </span>
        </button>
        <div class="dropdown">
          <button class="dropdown-toggle" @click="toggleMenu">
            Universe
            <span class="arrow">▼</span>
          </button>
          <div class="dropdown-menu" :class="{ 'show-mobile': isOpen }">
            <router-link @click="isOpen = false" class="dropdown-item" to="/">Home</router-link>
            <router-link @click="isOpen = false" class="dropdown-item" to="/ai-agents">AI Agents</router-link>
            <router-link @click="isOpen = false" class="dropdown-item" to="/solo">Solo Game</router-link>
            <router-link @click="isOpen = false" class="dropdown-item" to="/hide-seek">PvP Game</router-link>
            <router-link @click="isOpen = false" class="dropdown-item" to="/nft-market">NFT Market</router-link>
            <router-link @click="isOpen = false" class="dropdown-item" to="/dao">DAO Voting</router-link>
          </div>
        </div>
        <router-link v-if="!store.getters.isAuthenticated" class="header__nav-item-my-bitcat" to="/my"><strong>My BITCAT</strong></router-link>
        <router-link v-else class="header__nav-item-my-bitcat header__nav-item-my-bitcat-authenticated" to="/my">
          <span>{{ store.getters.userTag }}</span>
          <small v-if="store.getters.hasWallet">{{ shortWallet }}</small>
          <small v-else>not connected</small>
        </router-link>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, defineEmits, computed } from 'vue';
import store from '@/vuex';

const shortWallet = computed(() => {
  return store.getters.walletAddress ? store.getters.walletAddress.slice(0, 4) + '...' + store.getters.walletAddress.slice(-4) : 'not connected';
});

const isOpen = ref(false);
const isAiEnabled = ref(true);

const emit = defineEmits(['toggleAi']);

onMounted(() => {
  const aiEnabled = localStorage.getItem('bitcat_ai_enabled');
  isAiEnabled.value = aiEnabled === null ? true : aiEnabled === 'true';
});

const toggleAi = () => {
  isAiEnabled.value = !isAiEnabled.value;
  emit('toggleAi', isAiEnabled.value);
};

const toggleMenu = () => {
  isOpen.value = !isOpen.value;
};
</script>

<style>
  .header {
    display: flex;
    justify-content: center;
    padding: 10px 10px 40px;
    background-image: url('@/assets/coin.png');
    background-size: 28px;
    background-repeat: repeat-x;
    background-position: 0 95%;
  }

  .header__wrap {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: 20px;
    width: 100%;
    max-width: 1200px;
  }

  .header__left {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .header__logo {
    width: 100%;
    max-width: 200px;
  }

  .header__nav {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  .header__nav-item {
    color: #fff;
    font-size: 1.5em;
    text-decoration: none;
    white-space: nowrap;
  }

  .header__nav-item:hover {
    color: rgb(215, 77, 36);
  }

  .header__nav-item.router-link-active {
    color: rgb(215, 77, 36);
    text-decoration: underline;
  }

  .header__nav-item-my-bitcat {
    white-space: nowrap;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6px 12px;
    background: #fff;
    border-radius: 25px;
    position: relative;
    min-width: 120px;
    text-decoration: none;
    height: 41px;
    cursor: pointer;
    line-height: 0.8em;
    transition: all 0.3s ease;
    /* font-size: 1.5em; */
    box-shadow: 0 0 7px 0px rgba(0, 0, 0, 0.3) inset;
  }

  .header__nav-item-my-bitcat::before {
    content: '';
    position: absolute;
    height: 100%;
    width: 100%;
    padding: 4px;
    background: linear-gradient(135deg, #ff9800 0%, #d74d24 100%);
    border-radius: 25px;
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    cursor: pointer;
  }

  .header__nav-item-my-bitcat.router-link-active {
    box-shadow: 0 0 10px 5px rgba(215, 77, 36, 0.4), 0 0 7px 1px rgba(0, 0, 0, 0.4) inset;
  }

  .header__nav-item-my-bitcat strong {
    background: linear-gradient(135deg, #ff9800, #d74d24);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 1.2em;
  }

  .header__nav-item-my-bitcat span {
    background: linear-gradient(135deg, #ff9800, #d74d24);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: 600;
    font-size: 0.9rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
  }

  .header__nav-item-my-bitcat small {
    color: #666;
    font-size: 0.60rem;
    font-family: monospace;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 90px;
  }

  /* Custom Google Translate styles */
  .custom-translate {
    display: inline-block;
    position: relative;
  }

  .custom-translate .goog-te-gadget {
    font-family: 'Sour Gummy', sans-serif;
  }

  .custom-translate .goog-te-gadget-simple {
    background-color: #fff;
    background-image: url('@/assets/translate.png');
    background-size: 20px;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid rgb(215, 77, 36);
    border-radius: 4px;
    width: 30px;
    height: 30px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
  }

  .custom-translate .goog-te-gadget-simple:hover {
    background-color: #f7f7f7;
  }

  .custom-translate .goog-te-gadget-simple img {
    display: none;
  }

  .custom-translate .goog-te-menu-value {
    color: transparent;
    text-decoration: none;
    width: 100%;
    height: 100%;
    display: block;
  }

  .custom-translate .goog-te-menu-value span {
    display: none !important;
  }

  /* Hide Google Translate attribution */
  .goog-logo-link {
    display: none !important;
  }
  
  .goog-te-gadget {
    color: transparent !important;
  }

  /* Style dropdown menu */
  .goog-te-menu2 {
    background-color: #1a1a1a !important;
    border: 1px solid #444 !important;
  }

  .goog-te-menu2-item div, .goog-te-menu2-item:link div, .goog-te-menu2-item:visited div, .goog-te-menu2-item:active div {
    background-color: #1a1a1a !important;
    color: #fff !important;
  }

  .goog-te-menu2-item:hover div {
    background-color: #2a2a2a !important;
  }

  /* Hide Google Translate top bar */
  .goog-te-banner-frame {
    display: none !important;
  }
  .goog-te-spinner-pos {
    display: none !important;
  }
  body {
    top: 0 !important;
  }
  .VIpgJd-ZVi9od-l4eHX-hSRGPd,
  .VIpgJd-ZVi9od-ORHb-OEVmcd {
    display: none !important;
  }

  .dropdown {
    position: relative;
    display: inline-block;
  }

  .dropdown-toggle {
    background: linear-gradient(135deg, #ff9800 0%, rgb(215, 77, 36) 100%);
    color: white;
    padding: 10px 20px;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    transition: all 0.3s ease;
  }

  .dropdown-toggle:hover {
    background: linear-gradient(135deg, rgb(215, 77, 36) 0%, #ff9800 100%);
  }

  .arrow {
    font-size: 12px;
    transition: transform 0.3s ease;
  }

  .dropdown:hover .arrow {
    transform: rotate(180deg);
  }

  .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    background: rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(10px);
    min-width: 180px;
    border-radius: 12px;
    margin-top: 8px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.3s ease;
    border: 1px solid rgba(255, 152, 0, 0.2);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    overflow: hidden;
  }

  .dropdown:hover .dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  .dropdown-item {
    display: block;
    padding: 10px 15px;
    color: rgb(215, 77, 36);
    text-decoration: none;
    transition: all 0.2s ease;
  }

  .dropdown-item:hover {
    background: rgba(255, 152, 0, 0.2);
  }

  .dropdown-item.router-link-active {
    background: rgba(255, 152, 0, 0.5);
  }

  @media (max-width: 500px) {
    .header {
      padding-bottom: 50px;
    }
    .header__wrap {
      justify-content: center;
      gap: 8px;
    }
    .header__nav {
      justify-content: center;
    }
    .header__nav-item {
      font-size: 1.1em;
    }
  }

  @media (max-width: 550px) {
    .header__wrap {
      flex-direction: column;
    }
    .header__nav {
      width: 100%;
      margin-bottom: 10px;
      align-items: center;
    }
  }

  @media (max-width: 768px) {

    .dropdown-toggle {
      width: 100%;
      justify-content: center;
    }

    .dropdown-menu {
      position: static;
      width: 100%;
      opacity: 1;
      visibility: visible;
      transform: none;
      margin-top: 8px;
      display: none;
      position: absolute;
    }

    .show-mobile {
      display: block !important;
    }

    .dropdown:hover .dropdown-menu {
      display: none;
    }

    .dropdown-item {
      text-align: center;
    }

    .dropdown-item:hover {
      transform: none;
      background: rgba(255, 152, 0, 0.3);
    }
  }

  .universe-ai-button {
    position: relative;
    height: 36px;
    padding: 4px;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 3px;
    overflow: visible;
    justify-content: space-between;
  }

  .button-text {
    font-weight: 600;
    color: #fff;
    font-size: 1.25em;
    margin-right: 4px;
  }

  .switch-track {
    position: relative;
    width: 48px;
    height: 24px;
    background: rgba(215, 77, 36, 0.2);
    border: 2px solid var(--accent-color);
    border-radius: 34px;
    transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
    display: flex;
    align-items: center;
  }

  .switch-thumb {
    position: absolute;
    left: 2px;
    width: 20px;
    height: 20px;
    background: var(--accent-color);
    border-radius: 50%;
    transition: all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 12px;
    transform-origin: center;
  }

  .switch-thumb i {
    transition: transform 0.3s ease;
  }

  /* Enabled State */
  .ai-enabled .switch-track {
    background: var(--accent-color);
  }

  .ai-enabled .switch-thumb {
    left: calc(100% - 22px);
    background: #fff;
    color: var(--accent-color);
    transform: rotate(360deg);
  }

  /* Hover Effects */
  .universe-ai-button:hover .switch-track {
    box-shadow: 0 0 8px rgba(215, 77, 36, 0.4);
  }

  .universe-ai-button:hover .switch-thumb {
    transform: scale(1.1);
  }

  .ai-enabled:hover .switch-thumb {
    transform: rotate(360deg) scale(1.1);
  }

  /* Animation for icon */
  .switch-thumb i {
    animation: pulse 3s ease-in-out infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
  @media (max-width: 768px) {
    .switch-track {
      width: 56px;
      height: 28px;
    }
  
    .switch-thumb {
      width: 24px;
      height: 24px;
      font-size: 14px;
    }
  
    .ai-enabled .switch-thumb {
      left: calc(100% - 26px);
    }
  
    .button-text {
      font-size: 16px;
    }
  }

  :root {
    --accent-color: rgb(215, 77, 36);
  }
</style>